<template>
  <div class="filter">
    <div class="left">
      <van-tabs
        v-model:active="active"
        :ellipsis="false"
        swipeable
        :scrollspy="true"
        color="red"
        @change="changeTab"
      >
        <van-tab v-for="(item, i) in list" :key="i" :title="item.name" />
      </van-tabs>
    </div>
    <div class="right" @click="showFilter">
      <div class="line" />
      <p>{{ lang('筛选') }}</p>
      <img
        :class="show ? 'rotate180' : 'rotate0'"
        src="../../../assets/images/score/drop.png"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import lang from '@/langs'

const props = defineProps({
  tabIndex: {
    // 下拉区域始终为全屏的高度
    type: Number,
    default: 0
  },
  show: {
    type: Boolean,
    default: false
  }
})
const show = ref(props.show)
watch(
  () => props.show,
  (value) => {
    show.value = value
  }
)
const emits = defineEmits(['changeTab', 'showFilter'])
const showFilter = () => {
  emits('showFilter')
}
const curTab = ref(props.tabIndex)
watch(
  () => props.tabIndex,
  (value) => {
    curTab.value = value
  }
)
const changeTab = (value: number) => {
  curTab.value = list[value].value
  emits('changeTab', list[value].value)
}
const active = ref(0)
const list = [
  { name: lang('全部'), value: 0 },
  { name: lang('已完成'), value: 3 },
  { name: lang('已驳回'), value: 4 },
  { name: lang('待审核'), value: 2 },
  { name: lang('待上传'), value: 1 }
]
</script>

<style scoped lang="less">
.filter {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px;
  padding-bottom: 0;
  background: #fff;
  .left {
    flex: 1;
    overflow-x: auto;
  }

  .right {
    font-size: 14px;
    color: rgba(60, 60, 60, 1);
    display: flex;
    flex-direction: row;
    align-items: center;
    .line {
      width: 1px;
      background: #f7f7f7;
      height: 20px;
    }
    > img {
      height: 16px;
      width: 16px;
    }
    p {
      margin-left: 12px;
    }
    .rotate180 {
      display: inline-block;
      transform: rotate(180deg); /* 旋转 180 度 */
      transition: transform 0.3s ease; /* 添加平滑过渡（可选） */
    }
    .rotate0 {
      display: inline-block;
      transform: rotate(0deg); /* 旋转 180 度 */
      transition: transform 0.3s ease; /* 添加平滑过渡（可选） */
    }
  }
}
</style>
